module.exports = __webpack_public_path__ + "static/media/Rectangleactive.7cade754.svg";